<template>
   <div class="  is-fullheight sticky-sidebar" >
     <aside class="menu column  aside   is-fullheight" >
      <p class="menu-label">
        Samples
      </p>
      <ul class="menu-list">
        <li>
          <a class="">Rep/Sales Admin</a>
          <ul>
            <li @click="activeMenuLink = '/samples/new-request'" ><router-link to="/samples/new-request"  :class="{'is-active':activeMenuLink === '/samples/new-request'}">New Request</router-link></li>
            <li ><a href="/samples/list-samples/mysamples"  @click="activeMenuLink = '/samples/list-samples/mysamples'" :class="{'is-active':activeMenuLink === '/samples/list-samples/mysamples'}">List My Requests</a></li>
             </ul>
        </li>
        <li v-if="task_allowed('samples_artwork')">
          <a class="">Production</a>
          <ul>
            <li><a @click="activeMenuLink = '/samples/list-samples/new'" href="/samples/list-samples/new"  :class="{'is-active':activeMenuLink === '/samples/list-samples/new'}">New Sample Requests</a></li>
            <li ><a href="/samples/list-samples/inprogress" @click="activeMenuLink = '/samples/list-samples/inprogress'"  :class="{'is-active':activeMenuLink === '/samples/list-samples/inprogress'}">In Progress</a></li>
            </ul>
        </li>
        <li v-if="task_allowed('samples_production')">
          <a class="">Production</a>
          <ul>
            <li ><a href="/samples/list-samples/artwork"  :class="{'is-active':activeMenuLink === '/samples/list-samples/artwork'}" @click="activeMenuLink = '/samples/list-samples/artwork'">Requests Needing Artwork</a></li>
            <li ><a href="/samples/list-samples/digital-print"  :class="{'is-active':activeMenuLink === '/samples/list-samples/digital-print'}" @click="activeMenuLink = '/samples/list-samples/digital-print'">Requests Needing Digi. Print</a></li>
            <li ><a href="/samples/list-samples/makeup"  :class="{'is-active':activeMenuLink === '/samples/list-samples/makeup'}" @click="activeMenuLink = '/samples/list-samples/digital-print'">Requests Needing Makeup</a></li>
            
            <li @click="activeMenuLink = '/samples/data-input'"><router-link to="/samples/data-input"  :class="{'is-active':activeMenuLink === '/samples/data-input'}">Data Input</router-link></li>
            
            </ul>
        </li>

       
        
        
        
      </ul>
      
    </aside>
    
   </div>
</template>

<script>
import OrderMixin from "@/mixins/OrderMixin.js";

export default {
  name: 'SideBarOffshore',
  components: {
  },
  mixins: [OrderMixin],
  data() {
    return { 
      activeMenuLink: null,
      user: {tasks: []},
     }
  },
  mounted() {
    //this.activeMenuLink = this.$route.path.substring(1)
    this.activeMenuLink = this.$route.path
    console.log(this.activeMenuLink)
  },
  created() {
		this.getAccessToken()
        .then(() => { 
           this.getUserProfile(1); // 1 for with_tasks
        });
	}
}

</script>



